"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.name.placeholder': '输入项目名',
};
